import color from "@definitions/mui/color";
import { makeStyles } from "@mui/styles";

const useStyles = ({ url }: { url: string }) => {
  return makeStyles(() => ({
    base: {
      marginTop: 70,
    },
    gainAccess: {
      backgroundImage: `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)), url("${url}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      padding: 60,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    mediaHome: {
      maxWidth: 426,
      height: 320,
      borderRadius: "24px",
      objectFit: "cover",
    },
    titleReguler: {
      fontSize: 32,
      marginBottom: 24,
      lineHeight: "48px",
    },
    roundNumber: {
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      padding: "8px",
      background: color.primary.lighter,
      textAlign: "center",
    },
    image: {
      borderRadius: 8,
    },
    containerUVP: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center",
      width: 270,
      flexWrap: "wrap",
      gap: 1,
    },
    interestButtonContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      gap: "24px",
    },
    whatsAppButton: {
      background: "rgba(253, 253, 253, 0.25)",
      border: "1px solid rgba(253, 253, 253, 1)",
      color: "white",
      "&:hover": {
        background: "white",
        border: "1px solid rgba(253, 253, 253, 1)",
        color: "black",
      },
    },
    wrapperHtmlContent: {
      '& li': {
        whiteSpace: 'normal' + '!important'
      }
    }
  }))();
};

export default useStyles;
